import { populateStateProvince } from 'ui/forms';
import { lpPasswordToggle } from 'ui/password-toggle';
import { domReady, initBlockEnterKeyForDisabledButton, initRegularFormSubmissionActivity } from 'utilities/dom';
import { utagLinkCreateAccount } from 'features/tealium';
import { setGenericEvent } from 'features/tealium/ga4/custom';

domReady(() => {

	const $countrySelect = $('#ddlCompanyCountry');
	const $stateSelect = $('#ddlCompanyState');
	const dlCountry = document.getElementById('dlCountry');
	const showCountry = document.getElementById('showCountry');
	const showCountryLink = document.querySelector('#showCountry a');
	const chkBusinessCustomer = document.getElementById('chkBusinessCustomer');
	const toggleRevealPassword = document.querySelector('.toggleRevealPassword');
	const submitFormBtn = document.getElementById('createAccountBtn');
	const proInfo = document.getElementById('proInfo');
	const signIn = document.getElementById('SignIn');
	const trackCreateAccountEvents = utagLinkCreateAccount();
	const accountFacebookConnectBtn = document.getElementById('accountFacebookConnectBtn');
	const showAddressBtn = document.querySelector('.showAnotherAddressField');
	const showCountryField = document.querySelector('.showCountryField');
	const showAddressTwo = document.querySelector('.companyAddress');
	const contryField = document.querySelector('.countryField');
	const alreadyProsError = document.querySelector('.alreadyProsError');
	const createAccountForm = document.querySelector('.createAccount__form');
	const urlParams = new URLSearchParams(window.location.search);
	const accountType = urlParams?.get('accountType');
	const isCreateAccountPage = window.location.pathname.indexOf('account/create') > 0;

	// populate states if proInfo is showing
	if (proInfo && !proInfo.classList.contains('hidden')) {

		populateStateProvince($stateSelect, $countrySelect, $stateSelect.val() || null);

	}

	if (submitFormBtn) {

		submitFormBtn.classList.remove('proRequestedPrevent');

		submitFormBtn.addEventListener('click', (e) => {

			e.preventDefault();

			if ($('.createAccount__form').valid()) {

				if (alreadyProsError) {

					e.stopImmediatePropagation();
					alreadyProsError.style.display = 'block';

				} else {

					trackCreateAccountEvents({ eventCategory: 'Create Account', eventAction: eventActionSubmit });

					if (
						!submitFormBtn.classList.contains('createAccountBtnPros')
						&& !submitFormBtn.classList.contains('createAccountBtnHospitality')
					) {

						setGenericEvent({ event_name: 'createaccount_create_click' });

					}

				}

			} else {

				createAccountForm?.querySelector('input.error')?.focus();

			}

		});

	}

	initBlockEnterKeyForDisabledButton(submitFormBtn);
	initRegularFormSubmissionActivity(submitFormBtn);

	let eventActionSubmit = 'Click-Create-Account';
	let eventActionFb = 'Click-Facebook-Create';

	if (submitFormBtn.classList.contains('createAccountBtnPros')) {

		eventActionSubmit = 'Click-Create-Account-Pro';
		eventActionFb = 'Click-Facebook-Create-Pro';

	} else if (submitFormBtn.classList.contains('createAccountBtnHospitality')) {

		eventActionSubmit = 'Click-Create-Account-Hospitality';
		eventActionFb = 'Click-Facebook-Create-Hospitality';

	} else if (submitFormBtn.classList.contains('updateAccountBtn')) {

		eventActionSubmit = 'Click-Update-Account-Pro';

	} else if (submitFormBtn.classList.contains('updateAccountBtnHospitality')) {

		eventActionSubmit = 'Click-Update-Account-Hospitality';

	}

	if (accountFacebookConnectBtn) {

		accountFacebookConnectBtn.addEventListener('click', (e) => {

			trackCreateAccountEvents({ eventCategory: 'Create Account', eventAction: eventActionFb });
			if (
				isCreateAccountPage
				&& !(
					accountType
					&& (accountType.toLowerCase() === 'hospitality' || accountType.toLowerCase() === 'professional')
				)
			) {

				setGenericEvent({ event_name: 'createaccount_facebook_click' });

			}

		});

	}

	if (signIn) {

		signIn.addEventListener('click', (e) => {

			trackCreateAccountEvents({ eventAction: 'click-Sign-In' });

		});

	}

	if (showCountryLink) {

		showCountryLink.addEventListener('click', (e) => {

			e.preventDefault();

		});

	}

	if (window.parent !== window) {

		// if page is opened in a modal popup
		document.querySelectorAll('a').forEach((link) => {

			link.addEventListener('click', (e) => {

				e.preventDefault();
				window.parent.location.href = e.currentTarget.getAttribute('href');

			});

		});

	}

	function toggleForBusinessCustomer (isChecked) {

		if (proInfo) {

			if (isChecked) {

				proInfo.classList.remove('hidden');
				populateStateProvince($stateSelect, $countrySelect, $stateSelect.val() || null);

				return;

			}

			proInfo.classList.add('hidden');

		}

	}

	if (chkBusinessCustomer) {

		toggleForBusinessCustomer(chkBusinessCustomer.checked);

		chkBusinessCustomer.addEventListener('change', (e) => {

			toggleForBusinessCustomer(e.currentTarget.checked);

		});

	}

	$countrySelect.on('change', () => {

		populateStateProvince($stateSelect, $countrySelect, null);

	});

	if (toggleRevealPassword) {

		lpPasswordToggle(toggleRevealPassword);

	}

	if (showCountry) {

		showCountry.addEventListener('click', (e) => {

			e.preventDefault();
			e.currentTarget.classList.add('hidden');
			document.querySelector('.showCountryText').setAttribute('aria-expanded', 'true');
			dlCountry.classList.remove('hidden');

		});

	}

	if (window.lp.globals.canShowCertona) {

		window.lp.certona.getRecommendedItems();

	}

	// Overriding the validation rule for autofill to Solve issue of unnecessory validation events get fired on touch.
	$('.createAccount__form input[type=text]').change((e) => {

		e.preventDefault();
		e.stopImmediatePropagation();
		return false;

	});

	if (showAddressBtn) {

		showAddressBtn.addEventListener('click', (event) => {

			event.preventDefault();
			showAddressBtn.classList.add('hidden');
			if (showAddressTwo) {

				showAddressTwo.classList.remove('hidden');

			}
			showAddressBtn.setAttribute('aria-expanded', true);

		});

	}
	if (showCountryField) {

		showCountryField.addEventListener('click', (event) => {

			event.preventDefault();
			showCountryField.classList.add('hidden');
			if (contryField) {

				contryField.classList.remove('hidden');

			}
			showCountryField.setAttribute('aria-expanded', true);

		});

	}

	window.initFormValidation(true, '.createAccount__form');

});
